<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 表单 -->
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input
              @change="searchList"
              clearable
              v-model="queryParams.fullname"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              @change="searchList"
              clearable
              v-model="queryParams.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户公司名称">
            <el-input
              @change="searchList"
              clearable
              v-model="queryParams.company_name"
              placeholder="请输入客户公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业类型">
            <el-select
              @change="searchList"
              v-model="queryParams.company_type"
              clearable
              placeholder="请选择企业类型"
            >
              <el-option
                v-for="item in businessOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户状态">
            <el-select
              @change="searchList"
              v-model="queryParams.status"
              clearable
              placeholder="请选择客户状态"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="确认时间">
            <el-date-picker
              @change="handleChangeTime"
              v-model="queryParams.time"
              clearable
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              style="width:80px;margin-left: 20px;"
              type="primary"
              @click="handleExport"
              >导出</el-button
            >
          </el-form-item>
        </el-form>
        <div>
          <el-table v-loading="loading" :data="tableData" style="width: 100%;height: 550px;margin-top: 20px;">
            <el-table-column
              type="index"
              align="center"
              label="序号"
              width="50"
            >
            </el-table-column>
            <el-table-column
              prop="fullname"
              align="center"
              show-overflow-tooltip
              label="销售姓名"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.user.fullname }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="mobile"
              align="center"
              show-overflow-tooltip
              label="手机号"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.user.mobile }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="company_name"
              align="center"
              show-overflow-tooltip
              label="客户公司名称"
            >
            </el-table-column>
            <el-table-column
              prop="company_type"
              align="center"
              show-overflow-tooltip
              :formatter="formatterCompanyType"
              label="企业类型"
            >
            </el-table-column>
            <el-table-column
              prop="principal"
              align="center"
              show-overflow-tooltip
              label="负责人姓名"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.company.contact }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              align="center"
              show-overflow-tooltip
              label="负责人电话"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.company.contact_phone }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="created_at"
              align="center"
              show-overflow-tooltip
              label="确认时间"
            >
            </el-table-column>
            <el-table-column
              prop="status"
              align="center"
              show-overflow-tooltip
              label="客户状态"
              :formatter="formatterStatus"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
              width="100px"
              fixed="right"
            >
            <template slot-scope="scope">
              <el-button type="text" @click="look(scope.row)">查看</el-button>
            </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="page-box">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              :current-page="queryParams.current_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </PageHeaderLayout>
    <el-dialog
      :visible.sync="shareDialogVisible"
      width="480px"
      :close-on-click-modal="false"
      center
      :before-close="handleClose"
    >
    <div style="text-align: center;">
      <iframe :src="shareUrl"  frameborder="0" seamless  width="400px" height="800x"  scrolling="auto"></iframe>
    </div>
  </el-dialog>
  </div>
</template>
<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
export default {
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      loading:false,
      shareDialogVisible:false,
      shareUrl:'',
      baseUrl:'https://h5.khl.top',
      total:null,
      queryParams: {
        fullname: null,
        mobile: null,
        company_name: null,
        company_type: null,
        status: null,
        start_time: null,
        end_time: null,
        time: null,
        current_page: 1,
        page_size: 10,
      },
      businessOptions: [
        {
          value: "1",
          label: "人资企业",
        },
        {
          value: "2",
          label: "用工企业",
        },
      ],
      statusOptions: [
        {
          value: "0",
          label: "未确认",
        },
        {
          value: "1",
          label: "已确认",
        },
        // {
        //   value: "2",
        //   label: "已拒绝",
        // },
      ],
      tableData: [],
    };
  },
  methods: {
    // 导出
   async handleExport() {
      const res = await this.$api.getShareRecordList({current_page:1,page_size:99999});
      let list = res.data
      let bookType = "xlsx";
      import("@/excel/Export2Excel").then((excel) => {
        let tHeader = [
          "销售姓名",
          "手机号",
          "客户公司名称",
          "企业类型",
          "负责人姓名",
          "负责人电话",
          "确认时间",
          "客户状态",
        ];
        const data = this.formatJson(list);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `分享记录${time}`;
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: bookType, //Optional
        });
      });
    },
    // 搜索查询
    searchList(){
      this.queryParams.current_page = 1
      this.getList()
    },
    handleSizeChange(size) {
      this.queryParams.page_size = size;
      this.getList();
    },
    handleCurrentChange(page) {
      this.queryParams.current_page = page;
      this.getList();
    },
    handleClose(done){
      this.shareUrl = ''
      done()
    },
    // 详情
    look(row) {
      this.shareUrl = `${this.baseUrl}/#/pages/sale/reg?id=`+ row.id +'&type=show'
      this.shareDialogVisible = true
    },
    // 格式化数据
    formatJson(jsonData) {
      return jsonData.map((item) => {
        if (item.status == 0) {
          item.status = "未确认";
        } else if (item.status == 1) {
          item.status =  "已确认";
        } else if (item.status == 2) {
          item.status = "已拒绝";
        }
        return [
          item.user.fullname,
          item.user.mobile,
          item.company_name,
          item.company_type== 1?'人资企业':'用工企业',
          item.company.contact,
          item.company.contact_phone,
          item.created_at,
          item.status,
        ];
      });
    },
    // 格式化列表数据
    formatterStatus(row) {
      if (row.status == 0) {
        return "未确认";
      } else if (row.status == 1) {
        return "已确认";
      } else if (row.status == 2) {
        return "已拒绝";
      }
    },
    formatterCompanyType(row) {
      if (row.company_type == 1) {
        return "人资企业";
      } else if (row.company_type == 2) {
        return "用工企业";
      }
    },
    // 修改时间
    handleChangeTime() {
      if (this.queryParams.time) {
        this.getList();
      } else {
        this.queryParams.start_time = null;
        this.queryParams.end_time = null;
        this.getList();
      }
    },
    // 获取列表
    async getList() {
      this.loading = true
      if (this.queryParams.time) {
        this.queryParams.start_time = this.queryParams.time[0];
        this.queryParams.end_time = this.queryParams.time[1];
      }
      let obj = JSON.parse(JSON.stringify(this.queryParams))
      delete obj.time;
      // 为空就清空元素
      for (let i in obj) {
        // console.log(i, obj[i])  //i是键名，obj[i]是键值
        if(obj[i] == ''){
          delete obj[i]
        }
      }
      const res = await this.$api.getShareRecordList(obj);
      this.tableData = res.data;
      this.total = res.pages.total
      this.loading = false
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.main-page-content {
  margin-top: 20px;
  min-width: 1200px;
  .page-box {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
